
export default {
  props: {
    info: Object,
  },
  data() {
        return {
            summary: '',
    }
  },
  computed: {
    changee() {
      let changeVal = ''
      console.log(this.info.summary)
      changeVal = this.info.summary.replaceAll('\n', '<br>')

      /* 
        220518 meej 종목입체분석 : 기업개요 최종업데이트 일자 추가, 조건 추가
       */
      if(this.info.lastUpdateTime !== undefined){
        const lastUpdate = ""+this.info.lastUpdateTime
        const YYYY = lastUpdate.substring(0, 4)
        const  MM = lastUpdate.substring(4, 6)
        const  DD = lastUpdate.substring(6, 8)
  
        changeVal += "<br><br> Update : "+ YYYY + '-' + MM + '-' + DD
      }
      console.log(changeVal)
      return changeVal
    },
 },
}
